import React, { useId } from 'react';
import Select from 'react-select';
import './styles.scoped.css';

const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '38px',
    borderColor: state.isFocused ? '#da0f2e' : '#ced4da',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(218, 15, 46, 0.25)' : 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#da0f2e' : '#ced4da',
    },
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '0 8px',
  }),
  input: provided => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: provided => ({
    ...provided,
    height: '38px',
  }),
  menuList: provided => ({
    ...provided,
    maxHeight: '200px',
  }),
  menu: provided => ({
    ...provided,
    zIndex: 100000,
  }),
  menuPortal: provided => ({
    ...provided,
    zIndex: 100000,
  }),
  option: provided => ({
    ...provided,
    backgroundColor: 'transparent',
    color: '#212529',
    '&:hover': {
      backgroundColor: '#f8f9fa',
    },
    '&:active': {
      backgroundColor: '#f8f9fa',
    },
  }),
};

const errorStyles = {
  ...selectStyles,
  control: (provided, state) => ({
    ...selectStyles.control(provided, state),
    borderColor: '#da0f2e',
  }),
};

const FormSelectField = ({
  label,
  required = false,
  error,
  errorMessage,
  loading = false,
  disabled = false,
  placeholder = 'Select...',
  defaultValue,
  className = '',
  style = {},
  options = [],
  ...rest
}) => {
  const fieldId = useId();
  const errorId = `${fieldId}-error`;

  return (
    <div className={`form-select-field ${className}`} style={style}>
      {label && (
        <label htmlFor={fieldId} className={`label ${required ? 'required' : ''}`}>
          {label}
        </label>
      )}
      <div className="input-wrapper">
        <div className="input-row">
          <Select
            inputId={fieldId}
            styles={error ? errorStyles : selectStyles}
            options={options}
            isDisabled={disabled}
            isLoading={loading}
            placeholder={placeholder}
            defaultValue={defaultValue}
            menuPortalTarget={document.body}
            aria-required={required || undefined}
            aria-invalid={!!error || undefined}
            aria-describedby={error ? errorId : undefined}
            {...rest}
          />
          {loading && <span className="spinner" />}
        </div>
        {error && errorMessage && (
          <span id={errorId} className="error-message">
            {errorMessage}
          </span>
        )}
      </div>
    </div>
  );
};

export default FormSelectField;
